export class ServiceError extends Error {
    public code: string
    public description: string
    public status: number
    /**
     * Le `detail.context` rendu par l'API métier (DEV-1660).
     *
     * Sur `POST /cstb-record`, le code d'erreur est `error-ajout` pour TOUT
     * refus de création ; le seul discriminant du doublon d'email est
     * `context.message === "L'email est déjà enregistré"`
     * (api-ww `cstb-record.controller.ts` + `filters/http-exception.filter.ts`).
     * Sans ce champ, le front ne peut pas distinguer un doublon d'un autre
     * refus — et proposait donc un réessai qui rejouait le même refus.
     */
    public context?: Record<string, any>

    constructor(
        data: {
            message: string
            code: string
            description: string
            context?: Record<string, any>
        },
        status: number
    ) {
        super(data.message)
        this.name = "ServiceError"
        this.message = data.message
        this.code = data.code
        this.description = data.description
        this.context = data.context
        this.status = status
    }
}
